import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigColumnDef } from './config-table.component';

@Component({
  selector: 'app-config-customer-type',
  template: `<app-config-table
    tableName="Customer Types"
    [columns]="columns"
    permissionKey="Config.Manage"
    [loadFn]="load"
    [createFn]="create"
    [updateFn]="update"
    [deactivateFn]="deactivate"
    [deleteFn]="delete">
  </app-config-table>`,
})
export class CustomerTypeConfigComponent {
  columns: ConfigColumnDef[] = [
    { field: 'name',        label: 'Name',        type: 'text',     required: true, maxLength: 64 },
    { field: 'description', label: 'Description',  type: 'textarea', maxLength: 255 },
    { field: 'sortOrder',   label: 'Sort Order',   type: 'number' },
  ];

  constructor(private http: HttpClient) {
    this.load       = () => this.http.get<any[]>('/api/config/customer-types');
    this.create     = (d: any) => this.http.post('/api/config/customer-types', d);
    this.update     = (id: any, d: any) => this.http.put(`/api/config/customer-types/${id}`, d);
    this.deactivate = (id: any) => this.http.delete<void>(`/api/config/customer-types/${id}`);
    this.delete     = (id: any) => this.http.delete<any>(`/api/config/customer-types/${id}/permanent`);
  }

  load!: () => Observable<any[]>;
  create!: (d: any) => Observable<any>;
  update!: (id: any, d: any) => Observable<any>;
  deactivate!: (id: any) => Observable<void>;
  delete!: (id: any) => Observable<any>;
}
